import React from "react";
import { Alert, Typography } from "antd";
import { EnvironmentOutlined, AimOutlined, SmileOutlined, BulbOutlined } from "@ant-design/icons";
import CustomCard from "../extraShit/CustomCard";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./hawaii.css";

const { Title, Paragraph } = Typography;

const Hawaii: React.FC = () => {
    const { t } = useTranslation();
    const setupLines = [
        { key: "line1", icon: <AimOutlined />, text: t("games.details.hawaii.setup.line1") },
        { key: "line2", icon: <EnvironmentOutlined />, text: t("games.details.hawaii.setup.line2") },
        { key: "line3", icon: <SmileOutlined />, text: t("games.details.hawaii.setup.line3") },
    ];

    return (
        <GamePage game="hawaii" tagColor="lime" instructionIcons={[
            <AimOutlined key="flick" />,
            <EnvironmentOutlined key="island" />,
            <SmileOutlined key="miss" />,
            <BulbOutlined key="twist" />,
        ]}>
            <CustomCard title={<Title level={2}>{t("games.details.hawaii.setup.title")}</Title>}>
                <Paragraph className="hawaii-setup">
                    {setupLines.map((line) => (
                        <span className="hawaii-setup__line" key={line.key}>
                            {line.icon} {line.text}
                        </span>
                    ))}
                </Paragraph>
            </CustomCard>

            <CustomCard title={<Title level={2}><SmileOutlined /> {t("games.details.hawaii.rulesTitle")}</Title>}>
                <ol className="hawaii-rules">
                    <li>{t("games.details.hawaii.rules.flick")}</li>
                    <li><strong>{t("games.details.hawaii.rules.hitIsland.question")}</strong> {t("games.details.hawaii.rules.hitIsland.answer")}</li>
                    <li><strong>{t("games.details.hawaii.rules.hitHawaii")}</strong> {t("games.details.hawaii.rules.everyoneDrinks")}</li>
                    <li>
                        <strong>{t("games.details.hawaii.rules.miss.question")}</strong>
                        <br />
                        {t("games.details.hawaii.rules.miss.answer")}
                    </li>
                    <li>{t("games.details.hawaii.rules.rotate")}</li>
                    <li><strong>{t("games.details.hawaii.rules.twist.title")}</strong> {t("games.details.hawaii.rules.twist.description")}</li>
                </ol>
            </CustomCard>

            <CustomCard title={<Title level={2}>{t("games.details.hawaii.exampleTitle")}</Title>}>
                <img className="hawaii-example" src="/cards/hawai.png" alt={t("games.details.hawaii.exampleAlt")} />
            </CustomCard>
            <Alert
                message={<><BulbOutlined aria-hidden="true" /> <strong>{t("games.details.hawaii.tip.title")}</strong> {t("games.details.hawaii.tip.text")}</>}
                type="info"
                showIcon
            />
            <Paragraph type="secondary" className="hawaii-footer">{t("games.details.hawaii.footer")}</Paragraph>
        </GamePage>
    );
};

export default Hawaii;
